<ion-toolbar>
  <div class="main flex items-center justify-between">
    <a [attr.href]="!disabled ? 'https://copyfly.es/' : null" rel="noopener noreferrer">
      <img
        class="adjust-bottom"
        src="../../assets/images/logo/logo-blanco.svg"
        style="width: 125px; height: auto; margin: 0px"
      />
    </a>

    <ion-buttons class="menu-button">
      <ion-button
        [disabled]="disabled"
        routerLink="/"
        [routerLinkActive]="['is-active']"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <svg
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 150 150"
          style="enable-background: new 0 0 150 150"
          xml:space="preserve"
        >
          <g id="Layer_1"></g>
          <g>
            <g id="_x31_3">
              <g>
                <path
                  d="M143.6,63.5c0-4,1.1-9.9-0.8-13.7c-3.1-6.5-15-3.9-20.9-3.8c0-1.5-0.1-3.1-0.1-4.6c0.2-7.9,2.2-18.7,0.5-26.5
				c-0.6-2.9-1.1-3.9-4-4.9c-5.9-2.1-15-0.7-21.1-0.8C76.2,9,54.8,8.4,33.8,9.9c-0.4-0.1-0.9,0-1.4,0.1c-3,1-3.3,1.9-4,4.9
				c-1.7,7.9,0.4,18.4,0.5,26.5c0,1.5,0,3-0.1,4.5c-6.4-0.5-16.6-2-20.2,2.6C6.7,51,7.2,55,7.2,58c-0.1,6.8,0,13.6,0,20.4
				c0,6.8-0.1,13.6,0,20.4c0,3.5-0.6,7.9,2,10.8c3.7,4.3,12.6,3.9,18.8,4.1c0,0.3,0,0.7,0,1c0,6.2-1.7,15.2,0.6,21
				c1.7,4.3,4.9,4.3,9,4.5c9.4,0.5,18.9,0.1,28.3,0.1c5.9,0,11.8,0,17.8,0c4.9,0,9.8,0,14.7-0.1c5.6,0,15.6,2,20.7-0.7
				c6.8-3.7,4.7-17.8,4.1-25.8c5.9-0.3,14.7,0.1,18.5-3.8c2-2.1,2.1-4.8,2.2-7.4c0.4-6.7,0-13.7,0-20.4
				C143.7,75.9,143.7,69.7,143.6,63.5z M88.4,15.2c7.5,0.1,17.4-1.4,24.8,0.5c4.2,1,1.8-1.5,3.1,3.1c0.9,3.2-0.2,8.1-0.2,11.4
				c-0.1,3.7,1.6,21.8-1.7,23.8c-1.5,0.9-6.8-0.1-8.4-0.1c-4,0-8,0-11.9,0c-10,0-20,0-29.9,0c-8.2,0-16.8,0.9-24.9,0.1
				c-6.4-0.6-4.3-6.5-4.4-12.4c0-2.6-1.4-24.5-0.9-25.6C52,14.5,70.3,15,88.4,15.2z M116.9,129.9c-2.8,8-26,4.5-33.9,4.5
				c-5.7,0-11.5,0-17.2,0c-7.4,0-15.2,0.5-22.6-0.1c-2.4,0.5-4.5,0.1-6.5-1.3c-3-0.4-3.9-2.1-2.7-5.1c-0.8-3.4,0-8,0-11.4
				c0-1-0.1-2.6-0.3-4.5c0.2-0.7,0.1-1.5-0.2-2.2c-0.4-5.2-0.6-11.5,1.4-13.2c1.7-1.5,4.7-0.9,7.1-0.9c17,0,34,0,51,0
				c6.3,0,13.9-1.2,20.1,0c6.1,1.1,4,7.9,4,13.3C116.9,114.9,118.7,124.6,116.9,129.9z M137.8,102.5c-2.1,5-9.5,5-14.7,5.3
				c0.5-6.8,1.7-16-5.8-17.8c-6.1-1.4-13.9-0.2-20.1-0.2c-10,0-20,0-30,0c-8.4,0-16.8,0-25.2,0c-5.2,0-11.3-1.1-13.6,4.7
				c-1.4,3.5-1.1,8.6-0.8,13.2c-5.4-0.2-12.1-0.4-14.5-5.3c-1.2-2.5,0-8.2,0-11.1c0-4.3,0-8.7,0-13c0-6-1.9-16.7,0-22.3
				c1.8-5.3,9.9-4.5,15.8-4.2c0.4,4.3,2.2,7.5,8.2,7.8C55,60.6,73.1,59.6,91,59.7c7.5,0,15.1,0.4,22.7,0.1c6-0.3,7.7-3.5,8.2-7.7
				c3.2-0.1,7.8-0.7,10.8,0c6.7,1.4,5,4.4,5,9.7c0,6.8,0,13.6,0,20.4C137.7,87.3,139.8,97.8,137.8,102.5z M108.5,111.1
				c-21.8-1.1-43.5-1.2-65.3-0.3c-3.5,0.1-3.5-5.3,0-5.4c21.8-0.9,43.5-0.8,65.3,0.3C112,105.9,112,111.3,108.5,111.1z M107.4,125.6
				c-21-1.1-41.9-1.3-62.9-0.7c-3.5,0.1-3.5-5.3,0-5.4c21-0.7,41.9-0.4,62.9,0.7C110.8,120.4,110.8,125.8,107.4,125.6z"
                />
                <g>
                  <path
                    d="M144.4,63.5c0-6,2.1-14.8-5-17.7c-5.5-2.3-11.8-0.7-17.5-0.5c0.3,0.3,0.5,0.5,0.8,0.8c-0.2-5.5,0.3-11,0.8-16.5
					c0.4-5.1,0.7-10.5-0.5-15.6c-0.4-1.6-1-3-2.4-3.8c-1.7-1.1-4-1.5-6-1.8c-5.1-0.6-10.3,0-15.4,0.1C93,8.7,86.8,8.4,80.6,8.3
					c-6.4-0.1-12.8-0.2-19.2-0.1c-6.4,0-12.8,0.2-19.2,0.5c-1.6,0.1-3.3,0.2-4.9,0.3C35.8,9,34.3,9,32.9,9.2
					c-1.5,0.2-3.4,1.1-4.2,2.5c-1.1,1.8-1.3,4.4-1.5,6.5c-0.3,3-0.2,6.1,0,9.1c0.4,6.2,1.1,12.4,0.9,18.7c0.3-0.3,0.5-0.5,0.8-0.8
					c-5.6-0.5-11.9-1.6-17.3,0.4c-2.6,1-4.3,2.9-4.9,5.6c-0.3,1.6-0.3,3.2-0.3,4.8c0,2,0,3.9,0,5.9c0,9.1,0,18.3-0.1,27.4
					c0,4.1,0,8.2,0,12.3c0,3.1,0.2,6.5,2.5,8.8c2.2,2.2,5.5,3,8.5,3.5c3.5,0.5,7,0.5,10.5,0.6c-0.3-0.3-0.5-0.5-0.8-0.8
					c0.2,4.8-0.6,9.6-0.5,14.4c0.1,3.8,0.4,9.1,3.9,11.4c1.5,1,3.3,1.2,5,1.4c2.7,0.2,5.5,0.3,8.3,0.4c6.1,0.1,12.2-0.1,18.3-0.1
					c6.1,0,12.3,0,18.4,0c6.1,0,12.1-0.2,18.2,0c4.4,0.1,8.7,0.8,13.1,0.7c3.5-0.1,7.5-0.6,9.8-3.6c2.4-3.1,2.8-7.4,2.9-11.2
					c0.1-4.4-0.4-8.9-0.8-13.3c-0.3,0.3-0.5,0.5-0.8,0.8c3.6-0.2,7.3-0.1,10.9-0.6c3.2-0.5,6.8-1.5,8.8-4.3c1.1-1.6,1.4-3.5,1.6-5.3
					c0.2-2.4,0.3-4.8,0.3-7.3c0-5.2-0.2-10.4-0.2-15.6C144.4,75.4,144.4,69.5,144.4,63.5c0-1-1.5-1-1.5,0c0,9.7,0.1,19.4,0.2,29
					c0,2.4,0.1,4.9,0,7.3c-0.1,2.1-0.1,4.3-0.5,6.4c-0.9,3.8-4.2,5.3-7.6,5.9c-3.9,0.8-7.9,0.7-11.9,0.8c-0.4,0-0.8,0.3-0.8,0.8
					c0.3,3.7,0.7,7.3,0.7,11c0.1,3.5,0,7.3-1.4,10.6c-1.5,3.5-4.6,4.6-8.2,4.8c-4.2,0.3-8.4-0.3-12.6-0.5c-5.2-0.3-10.4-0.1-15.6,0
					c-5.8,0-11.7,0-17.5,0c-5.8,0-11.6,0.1-17.3,0.1c-5.2,0-10.6,0.2-15.8-0.5c-2.1-0.3-4-1-5-3c-1.2-2.2-1.4-4.9-1.5-7.4
					c-0.2-5.1,0.7-10.1,0.5-15.2c0-0.4-0.3-0.7-0.8-0.8c-2.9-0.1-5.7-0.1-8.6-0.3c-2.8-0.2-5.7-0.7-8.1-2.2
					c-2.8-1.8-3.4-4.9-3.4-8.1c0-3.7,0-7.4,0-11.1c0-8.3,0.1-16.6,0.1-24.9c0-3.8,0-7.5,0-11.3c0-2.9,0.3-6,3.1-7.6
					c2.6-1.4,5.8-1.5,8.7-1.5c3.1,0,6.1,0.4,9.1,0.6c0.4,0,0.7-0.4,0.8-0.8c0.1-5.2-0.3-10.3-0.7-15.5c-0.4-5.1-0.8-10.3,0.2-15.4
					c0.3-1.7,0.7-3.1,2.3-3.9c1.2-0.6,2.3-0.6,3.5-0.7c1.6-0.1,3.1-0.2,4.7-0.3c6.1-0.3,12.1-0.5,18.2-0.6C70,9.6,82.2,9.8,94.3,10
					c4.9,0.1,9.9-0.3,14.8-0.3c2.4,0,4.7,0.1,7.1,0.6c1.7,0.4,4,0.9,4.8,2.6c1,2.1,1.1,4.9,1.2,7.2c0.1,2.8,0,5.7-0.2,8.5
					c-0.4,5.9-1,11.6-0.8,17.5c0,0.4,0.3,0.8,0.8,0.8c5.3-0.2,10.9-1.6,16.1,0.1c7.1,2.2,4.9,11,4.8,16.6
					C142.9,64.5,144.4,64.5,144.4,63.5z"
                  />
                  <path
                    d="M88.4,15.9c7.7,0,15.7-1.3,23.3,0.2c1.2,0.2,2.4,0.7,3.6,0.6c0.2,0,0.6-0.1,0.6-0.1c0-0.1-0.7-0.7-0.7-0.6
					c0,0,0,0.3,0,0.4c-0.1,1.1,0.5,2.4,0.7,3.5c0.3,1.8,0.1,3.7-0.1,5.5c-0.2,2.4-0.4,4.7-0.3,7c0.1,2.3,0.2,4.6,0.3,6.8
					c0.1,2.6,0.1,5.3-0.1,7.9c-0.1,1.7-0.2,4-1.1,5.6c-0.4,0.7-1.2,0.8-2,0.8c-1.4,0.1-2.8-0.1-4.2-0.3c-3.8-0.4-7.7-0.2-11.5-0.2
					c-9.4,0-18.8,0-28.2,0c-8.9,0-17.9,0.8-26.9,0.3c-1.6-0.1-3.7,0-5.1-1.1c-1-0.8-1.3-2.1-1.3-3.3c-0.2-2.6,0.3-5.2,0.2-7.8
					c-0.2-8.1-1.1-16.1-1-24.2c0-0.2,0-0.5,0-0.7c0-0.2,0-0.1,0-0.2c-0.2,0.2-0.5,0.4-0.7,0.6C52.1,15.3,70.3,15.8,88.4,15.9
					c1,0,1-1.5,0-1.5c-18.2-0.1-36.3-0.6-54.5,0.7c-0.3,0-0.6,0.2-0.7,0.6c-0.3,1.1-0.1,2.5-0.1,3.5c0.1,2.4,0.2,4.7,0.3,7.1
					c0.2,4.6,0.5,9.3,0.7,13.9c0.1,2.3-0.1,4.5-0.2,6.7c-0.1,2.4,0,5.2,2.2,6.7c1.3,0.9,3,1,4.6,1.1c2.3,0.2,4.7,0.2,7,0.2
					c4.7,0,9.4-0.3,14.2-0.4c9.9-0.2,19.8,0,29.8,0c4.9,0,9.7-0.1,14.6,0c2.6,0.1,5.4,1,8,0.2c1.6-0.5,2.2-2.2,2.5-3.7
					c0.5-2.4,0.6-4.9,0.6-7.4c0-4.6-0.5-9.2-0.3-13.8c0.1-3.6,1.1-7.3,0.3-10.9c-0.2-1-0.4-1.9-0.5-2.9c-0.1-0.7-0.5-0.9-1.1-0.8
					c-0.9,0-1.9-0.2-2.9-0.4c-1.9-0.4-3.8-0.6-5.7-0.7c-4.2-0.2-8.4,0-12.7,0.2c-2,0.1-3.9,0.2-5.9,0.2
					C87.5,14.4,87.5,15.9,88.4,15.9z"
                  />
                  <path
                    d="M116.2,129.7c-0.7,1.8-2.6,2.8-4.3,3.4c-2.4,0.8-5,1.1-7.6,1.2c-5.6,0.3-11.3-0.1-16.9-0.5c-7.7-0.5-15.6-0.2-23.3-0.2
					c-4.9,0-9.8,0.3-14.7,0.2c-1.1,0-2.2,0-3.4-0.1c-1.2-0.1-2.3-0.2-3.5-0.1c-1.1,0.2-2.1,0.1-3.2-0.2c-1-0.3-1.9-1-2.9-1.3
					c-1.6-0.4-2.6-1-2.3-2.8c0.1-0.9,0.4-1.3,0.3-2.2c-0.2-1-0.2-2.1-0.2-3.1c0-2.1,0.2-4.2,0.3-6.3c0.1-1.9-0.3-3.8-0.2-5.7
					c0-2-0.4-4.1-0.4-6.1c-0.1-2-0.1-4,0.2-6c0.3-1.5,0.7-3,2.3-3.5c1.7-0.5,3.7-0.2,5.4-0.1c10.1,0.1,20.2,0,30.2,0
					c9.6,0,19.2,0.2,28.8-0.3c2.2-0.1,4.4-0.2,6.6-0.2c2,0,4.2,0.1,6.2,0.7c3.1,1.1,3,4.6,2.8,7.3c-0.2,3.2-0.3,6.4-0.1,9.6
					c0.3,3.7,0.7,7.5,0.5,11.2C116.9,126.5,116.7,128.2,116.2,129.7c-0.3,0.9,1.1,1.3,1.4,0.4c1.2-3.6,0.9-7.5,0.7-11.2
					c-0.2-3.7-0.8-7.5-0.6-11.2c0.2-3,0.9-6.3-0.2-9.2c-1.3-3.4-5.1-3.7-8.3-3.9c-4.7-0.3-9.3,0.2-13.9,0.4C90,95.2,84.7,95,79.3,95
					c-10.8,0-21.7,0-32.5,0c-2.4,0-4.9,0-7.3-0.1c-1.7-0.1-3.6-0.1-5,1c-2.5,1.9-2.2,6.6-2.1,9.3c0.1,4.3,0.9,8.5,0.7,12.8
					c-0.1,2.2-0.3,4.5-0.3,6.7c0,0.9,0.1,1.8,0.3,2.7c0.1,0.9-0.3,1.7-0.3,2.7c0,1.2,0.6,2.4,1.6,3c0.7,0.4,1.6,0.5,2.3,0.8
					c1,0.5,1.8,1,2.9,1.2c0.9,0.2,1.8,0.2,2.8,0.1c1.4-0.2,2.8,0,4.2,0.1c2.6,0.1,5.1,0.1,7.7,0.1c9.9-0.1,19.9-0.4,29.8-0.2
					c5.7,0.2,11.4,0.8,17.1,0.7c2.9,0,5.9-0.2,8.8-0.8c2.2-0.4,4.5-1.2,6.2-2.7c0.7-0.6,1.2-1.4,1.5-2.3
					C117.9,129.2,116.5,128.8,116.2,129.7z"
                  />
                  <path
                    d="M137.1,102.2c-2.3,5-9.5,4.7-14.1,4.9c0.3,0.3,0.5,0.5,0.8,0.8c0.4-5.3,1.7-13.2-3.2-17c-2.9-2.2-7.3-2.2-10.8-2.2
					c-4.5,0-9,0.5-13.4,0.5c-10.5,0-21,0-31.5,0c-5.2,0-10.4,0-15.6,0c-4.2,0-8.5-0.2-12.7-0.1c-3.5,0.1-7,1.1-8.7,4.5
					c-2.1,4.3-1.5,9.7-1.1,14.3c0.3-0.3,0.5-0.5,0.8-0.8c-4.4-0.2-10.9,0-13.5-4.3c-1.2-2-0.7-4.8-0.5-7c0.3-2.8,0.3-5.4,0.3-8.2
					c0-5.8,0-11.6-0.5-17.4C13.2,67.4,13,64.7,13,62c0.1-2.1,0.1-4.9,1.3-6.7c1.4-2.1,4.2-2.6,6.5-2.8c2.7-0.2,5.4,0,8.1,0.2
					c-0.3-0.3-0.5-0.5-0.8-0.8c0.2,2.1,0.7,4.2,2.2,5.9c1.6,1.8,4,2.5,6.4,2.7c8.1,0.6,16.4,0.4,24.6,0.3c8.2-0.1,16.5-0.3,24.7-0.4
					c8.2-0.1,16.4,0.4,24.6,0.2c3.1-0.1,6.6,0,9.1-2.2c1.9-1.6,2.5-4.1,2.8-6.4c-0.3,0.3-0.5,0.5-0.8,0.8c4.2-0.1,8.9-1.1,12.9,0.6
					c3,1.3,2.4,4.1,2.2,6.8c-0.2,5.5,0,11,0,16.4c0,4.3,0.2,8.5,0.6,12.9c0.4,4.1,1.1,9-0.5,12.9c-0.4,0.9,1.1,1.3,1.4,0.4
					c1.5-3.6,1-8.1,0.7-11.8c-0.2-2.1-0.4-4.2-0.6-6.4c-0.2-2.5-0.1-4.9-0.1-7.4c0-5.8-0.3-11.6,0-17.3c0.1-2.6,0.5-5.6-2-7.2
					c-4.2-2.7-10-1.4-14.6-1.3c-0.4,0-0.7,0.3-0.8,0.8c-0.2,2.1-0.9,4.3-2.6,5.6c-2.4,1.7-5.7,1.5-8.5,1.5
					c-7.5,0.1-14.9-0.2-22.4-0.2c-14.8,0.1-29.6,0.7-44.4,0.3c-2.1-0.1-4.2-0.1-6.3-0.2c-1.4-0.1-2.7-0.4-3.9-1.1
					c-2.1-1.3-2.9-3.7-3.1-6c0-0.4-0.3-0.7-0.8-0.8c-4.5-0.3-10.5-1.2-14.4,1.7c-1.8,1.4-2.4,3.4-2.7,5.5c-0.4,2.9-0.3,5.8-0.2,8.7
					c0.2,2.9,0.4,5.7,0.6,8.6c0.2,3.3,0.1,6.6,0.1,9.9c0,3.3,0,6.5-0.3,9.8c-0.2,2.3-0.7,5.1,0.3,7.3c2.4,5.6,10.1,5.6,15.2,5.8
					c0.4,0,0.8-0.4,0.8-0.8c-0.3-4.1-0.8-8.6,0.5-12.5c1.2-3.4,4.1-4.5,7.4-4.7c3.8-0.2,7.6,0.1,11.3,0.1c4.9,0,9.7,0,14.6,0
					c9.7,0,19.4,0,29.1,0c4.5,0,8.9-0.1,13.4-0.3c4.1-0.2,8.5-0.5,12.6,0.5c7.1,1.9,5.5,11.5,5.1,17c0,0.4,0.4,0.8,0.8,0.8
					c5.2-0.3,12.8-0.1,15.4-5.7C138.8,102,137.5,101.3,137.1,102.2z"
                  />
                  <path
                    d="M108.5,110.4c-20.5-1-41-1.1-61.5-0.4c-1.2,0-2.5,0.2-3.7,0.1c-0.7,0-1.2-0.2-1.6-0.8c-0.6-0.9-0.3-2.3,0.6-2.9
					c0.8-0.5,1.9-0.3,2.7-0.4c1.3-0.1,2.7-0.1,4-0.1c2.6-0.1,5.1-0.2,7.7-0.2c10.2-0.2,20.4-0.2,30.6,0c5.7,0.1,11.5,0.3,17.2,0.5
					c1.3,0.1,2.8,0,4.1,0.2c0.7,0.1,1.2,0.5,1.5,1.1C110.7,109,110,110.4,108.5,110.4c-1,0-1,1.5,0,1.5c2.8,0,4.3-3.1,2.8-5.4
					c-0.9-1.4-2.4-1.5-4-1.6c-2.9-0.1-5.8-0.3-8.7-0.4c-11.8-0.4-23.6-0.5-35.4-0.4c-5.9,0.1-11.8,0.2-17.7,0.4
					c-1.7,0.1-3.6-0.1-4.8,1.3c-0.8,0.9-1,2.3-0.7,3.5c0.4,1.2,1.4,2.1,2.7,2.2c1.1,0.1,2.4-0.1,3.5-0.1c1.6-0.1,3.2-0.1,4.7-0.2
					c5.9-0.2,11.8-0.3,17.7-0.3c13.3-0.1,26.6,0.2,39.9,0.9C109.4,111.9,109.4,110.4,108.5,110.4z"
                  />
                  <path
                    d="M107.4,124.9c-19.8-1-39.6-1.3-59.4-0.8c-1.2,0-2.4,0.2-3.6,0.1c-0.6,0-1.1-0.2-1.4-0.8c-0.5-0.9-0.3-2.3,0.6-2.8
					c0.8-0.5,1.9-0.3,2.7-0.3c1.2,0,2.5-0.1,3.7-0.1c2.5-0.1,5-0.1,7.4-0.1c9.9-0.1,19.8-0.1,29.7,0.2c5.6,0.1,11.2,0.4,16.8,0.6
					c1.6,0.1,4.5-0.4,5.2,1.4C109.6,123.6,108.8,124.9,107.4,124.9c-1,0-1,1.5,0,1.5c2.7,0,4.2-2.9,2.9-5.2c-0.7-1.3-2-1.7-3.4-1.7
					c-2.9-0.2-5.8-0.3-8.7-0.4c-11.5-0.5-22.9-0.7-34.4-0.6c-5.8,0-11.6,0.1-17.3,0.3c-1.6,0-3.4-0.1-4.5,1.2
					c-0.8,0.9-1,2.2-0.7,3.4c0.3,1.2,1.3,2.1,2.5,2.3c1,0.2,2.2,0,3.2,0c1.5,0,3-0.1,4.5-0.1c5.8-0.1,11.6-0.2,17.3-0.2
					c12.9,0,25.8,0.4,38.6,1C108.3,126.4,108.3,124.9,107.4,124.9z"
                  />
                </g>
              </g>
            </g>
            <g id="Layer_1_1_"></g>
          </g>
        </svg>
        <span class="option-text">Imprimir</span>
      </ion-button>
      <!-- queryParamsHandling="merge" -->
      <ion-button [disabled]="disabled" (click)="toStationery()" [routerLinkActive]="['is-active']" button>
        <svg
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 150 150"
          style="enable-background: new 0 0 150 150"
          xml:space="preserve"
        >
          <g id="Layer_1"></g>
          <g>
            <defs>
              <rect
                id="SVGID_1_"
                x="3.5"
                y="35.5"
                transform="matrix(0.7071 -0.7071 0.7071 0.7071 -30.3178 74.307)"
                width="142.2"
                height="76.5"
              />
            </defs>
            <clipPath id="SVGID_2_">
              <use xlink:href="#SVGID_1_" style="overflow: visible" />
            </clipPath>
            <g>
              <path
                d="M79.2,122.7c15.6-16.6,31.5-33.7,48.5-52.1c4.4-4.8,8.7-9.8,12.8-14.7c1-1.2,2-2.4,3-3.5c3.1-3.6,2.9-7-0.5-10.5
			c-0.1-0.1-0.3-0.3-0.4-0.4l-3.7-3.6c-3.2-3.1-6.4-6.2-9.6-9.2c-0.9-0.9-1.8-1.6-2.8-2.3c-2.5-1.6-3.9-1.5-6.1,0.4
			c-1.4,1.3-2.8,2.6-4.1,4c-10.5,11.2-21,22.4-32,34.2L75,75c-1.9,1.9-3.8,3.9-5.8,6c-5,5.2-10.1,10.5-15.5,15.9
			c-4.1,4.1-8.3,8.3-12.4,12.3c-3.1,3-6.3,6.2-9.4,9.3c-4.4,4.4-4.5,7.9-0.2,12.4c0.5,0.5,0.9,1,1.4,1.4c2.6,2.6,5.4,5.1,8.1,7.6
			c3.1,2.7,5.6,4.9,8,6.7c2.6,1.9,4.6,1.7,7-0.8l0.1-0.1c2.5-2.7,5.1-5.4,7.7-8c1.8-1.8,3.8-3.7,5.6-5.4
			C72.9,129.1,76.1,125.9,79.2,122.7z M44.2,117.1c0.3,0.2,0.6,0.5,0.9,0.7c0.9,0.7,1.8,1.3,2.7,1.9c2.7,1.6,4.4,0.8,5.4-0.2
			c1-1,1.9-2.8,0.1-5.4c-0.6-0.8-1.1-1.7-1.7-2.6c-0.2-0.3-0.4-0.6-0.6-0.9l5.3-5.3c0.1,0.1,0.3,0.2,0.4,0.4c0.6,0.5,1.3,1,2,1.5
			l0.5,0.3c0.9,0.7,2,1.2,3.1,1.5c0.6,0.1,1.3,0.1,1.9-0.1c0.6-0.2,1.1-0.6,1.5-1.1c0.4-0.6,0.7-1.3,0.8-2c0.1-0.7-0.1-1.5-0.4-2.1
			c-0.6-1.3-1.4-2.6-2.3-3.8c-0.3-0.4-0.6-0.9-0.9-1.3l5.1-5.1L69,94c0.9,0.6,1.8,1.2,2.8,1.9c0.7,0.5,2.7,1.9,4.5,0.2
			c2-1.8,0.6-4,0.1-4.8c-0.6-1-1.3-2-2-3c-0.2-0.3-0.5-0.7-0.7-1l5.2-5.2l0.1,0.1c0.5,0.4,1.1,0.8,1.6,1.2c0.2,0.1,0.4,0.2,0.6,0.4
			c0.7,0.6,1.6,1,2.6,1.2c1.1,0.1,3-0.3,3.6-1.4c0.3-0.6,0.5-1.3,0.5-2c0-0.7-0.1-1.4-0.4-2.1c-0.6-1.1-1.4-2.1-2.3-2.9
			c-0.3-0.3-0.5-0.6-0.8-0.8l5.7-5.7c0.2,0.1,0.4,0.3,0.6,0.5c0.8,0.6,1.7,1.3,2.6,2c2,1.4,3.9,1.4,5.1,0c1.5-1.8,0.7-3.4-0.3-4.8
			c-0.2-0.3-0.4-0.5-0.5-0.8c-0.3-0.4-0.5-0.8-0.8-1.2c-0.3-0.4-0.7-0.9-1.1-1.3l-0.3-0.3l5.7-5.7l0.7,0.4c0.9,0.5,1.8,1,2.8,1.6
			c1.1,0.6,3.5,1.9,5.3-0.3c1.7-2.1,0.2-4-0.7-5.3c-0.6-0.8-1.2-1.5-1.9-2.2c-0.2-0.2-0.4-0.5-0.6-0.7l5.3-6.1
			c0.3,0.2,0.6,0.5,0.9,0.7c1,0.7,1.9,1.4,2.8,2.1c2.9,2,4.6,0.8,5.3-0.1c1.8-2.1,0.3-4.2-0.3-5.1c-0.3-0.5-0.7-0.9-1-1.3
			c-0.2-0.3-0.4-0.5-0.6-0.8c-0.3-0.4-0.6-0.8-1-1.3l-0.3-0.5l4.7-5.2l15.4,14.4c-2.5,2.8-5.1,5.6-7.6,8.4
			c-24.7,27.2-50.2,55.3-77.5,80.9l-15.1-13.9L44.2,117.1z"
              />
              <path
                d="M25.1,71.6c-3.3,3.5-6.5,7.3-9.4,11.2c-3.1,4.1-3.6,9-1.5,14.2c0.8,1.9,1.9,3.5,3.3,5c2.3,2.3,5.4,3.6,8.7,3.7
			c5.4,0.2,10.2-1.5,13.6-4.8c2-2,3.9-4.1,5.8-6.1c1-1.1,2.1-2.3,3.1-3.4c5.9-6.3,11.9-12.7,19.2-20.4l9.9-10.5l3.6-3.7
			c4.8-4.9,11.3-11.7,17.9-18.5c1.5-1.5,2.5-3.4,2.8-5.5c0.4-2.2,0.9-4.5,1.3-6.7c0.2-1.2,0.5-2.3,0.7-3.5l0.4-1.9
			c0.6-3,1.2-6.1,1.8-9.2c0.4-2.5-0.3-3.8-1-4.5c-0.7-0.7-2.1-1.4-4.5-0.8c-1.4,0.4-2.7,0.9-4,1.5l-0.5,0.2
			c-4.7,2.2-9.6,4.4-14.3,6.7c-1.6,0.7-3,1.7-4.3,2.9c-4.3,4.2-8.7,8.7-14.4,14.6l-3.5,3.6C48.3,47.4,36.5,59.6,25.1,71.6z
			 M89.7,19.1l3.4-1.7c0.4,0.4,0.9,0.7,1.3,1c1.1,0.8,2.1,1.6,2.3,2.4c0.3,1,0,2.2-0.4,3.6c-0.1,0.4-0.2,0.7-0.3,1.1L89.7,19.1z
			 M24.9,97.2c-0.8-0.5-1.4-1.2-1.9-2c-0.5-0.8-0.8-1.7-0.9-2.6c-0.3-2.9,0.8-5.3,2.8-8.1L36.3,94c-1.9,2.1-4.4,3.5-7.2,4.1
			c-0.7,0.2-1.5,0.2-2.2,0C26.1,98,25.5,97.6,24.9,97.2L24.9,97.2z M31.8,77.7l50.1-52.8l8.8,8.8L40.8,86.7L31.8,77.7z"
              />
            </g>
          </g>
        </svg>
        <span class="option-text">Papelería</span>
      </ion-button>
      <ion-button
        [disabled]="disabled"
        routerLink="/papeleria/catalogo/libreta-personalizada"
        [routerLinkActive]="['is-active']"
        button
      >
        <ion-icon icon="/assets/icon/libreta-personalizada.svg"></ion-icon>
        <span class="option-text">Libretas personalizadas</span>
      </ion-button>
      <a [attr.href]="!disabled ? 'https://copyfly.es/embajadores' : null">
        <ion-button [disabled]="disabled">
          <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 150 150"
            style="enable-background: new 0 0 150 150"
            xml:space="preserve"
          >
            <style type="text/css">
              .st0 {
                clip-path: url(#SVGID_2_);
              }
            </style>
            <g id="Layer_1"></g>
            <g>
              <defs>
                <rect id="SVGID_1_" x="5" y="13.1" width="140" height="123.8" />
              </defs>
              <clipPath id="SVGID_2_">
                <use xlink:href="#SVGID_1_" style="overflow: visible" />
              </clipPath>
              <g>
                <path
                  d="M121.5,53.7c-2.1,0-3.3-0.5-4.1-2c-0.7-1.4-0.2-2.6,0.5-3.7c0.4-0.6,0.9-1.1,1.5-1.5c3.2-2,6.4-4.1,9.7-5.9
			c1.1-0.5,2.3-0.7,3.5-0.6c0.6,0.1,1.1,0.3,1.6,0.6c0.5,0.3,0.9,0.7,1.1,1.2c0.3,0.5,0.4,1,0.5,1.6c0,0.6-0.1,1.1-0.3,1.6
			c-0.6,1.3-1.5,2.4-2.7,3.2c-3,1.8-6.1,3.3-9.2,4.9C122.9,53.4,122.2,53.6,121.5,53.7z"
                />
                <path
                  d="M24.2,58c-0.7-0.4-2.2-0.9-3.2-1.9c-1.7-1.6-3.2-3.4-4.6-5.4c-0.7-1-1.1-2.2-1.2-3.4c0-2.2,2.4-3.8,4.7-3
			c2,0.6,3.8,1.6,5.4,2.9c1.6,1.3,2.9,2.9,3.8,4.8C30.8,55.2,28.6,58.1,24.2,58z"
                />
                <path
                  d="M109.2,13.4c3.2,0,5,2.3,4.4,4.8c-0.2,0.8-0.5,1.5-1.1,2.2c-2.1,2.2-4.3,4.4-6.6,6.4c-1.1,1-2.6,1.7-4.3,1.1
			c-2-0.7-3-2.3-2.3-4.3c0.2-0.6,0.4-1.2,0.8-1.6c2-2.3,4-4.7,6.1-6.9C107.2,14.3,108.5,13.8,109.2,13.4z"
                />
                <path
                  d="M53.2,25.1c-0.2,1.8-0.9,3.2-2.6,4c-1.5,0.7-2.9,0.2-3.9-0.8c-2.3-2.2-4.1-4.9-5.1-8c-0.7-2.1,0-3.9,1.5-4.9
			c1.6-1,3.4-0.9,5,0.8C50.5,18.7,52.5,21.5,53.2,25.1z"
                />
                <path
                  d="M144.3,72.5c0-1.5-0.3-3.1-0.8-4.5c-0.7-1.9-2-3.3-3.6-3.7c-1.6-0.5-3.4,0-5.1,1.4c-1.2,1-2.4,2.1-3.6,3.1
			c-0.5,0.4-1,0.9-1.4,1.3l-6.4,5.7c-5.2,4.6-10.5,9.3-15.7,13.9c-0.4,0.3-0.8,0.6-1.2,0.9c-0.2,0.1-0.3,0.2-0.5,0.3
			c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.2-0.4c-1.2-3.2-2.3-6.4-3.4-9.5
			c-2.5-7-5.1-14.3-7.9-21.3c-3.8-9.8-7.9-19.3-11.7-28.1c-1-2.1-2.4-4.1-4-5.7c-1.5-1.6-3.1-1.7-5.3-0.4c-1.8,1.1-2.5,2.9-3.3,4.8
			l-0.1,0.2c-0.8,1.9-1.6,3.9-2.4,5.8C64,42,61.6,48.1,58.9,54c-4,8.9-8.3,17.9-12.3,26.3c-1.4,2.9-2.9,5.6-4.5,8.5
			c-0.7,1.3-1.5,2.7-2.2,4.1c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.2s-0.3,0-0.4,0c-0.1,0-0.2-0.1-0.4-0.1l-2.6-1.6
			c-1.7-1-3.2-2-4.7-2.9c-2.1-1.3-4.2-2.7-6.3-4c-4.1-2.6-8.3-5.2-12.4-7.8c-0.9-0.7-2-1.1-3.2-1.2c-0.8,0-1.7,0.4-2.3,0.9
			c-1.8,1.5-2.3,3.3-1.6,5.6c0.5,1.5,1.2,3,1.8,4.4l0,0.1C8,87.8,8.6,89,9.1,90.1c1,2.2,2.1,4.4,3,6.7c0.5,1.4,1.1,2.9,1.7,4.3
			c3.5,9.3,7.2,18.8,9.6,28.7c0.8,3.3,2.7,5.2,5.9,5.5c0.9,0.1,1.7,0.2,2.6,0.3c3.6,0.5,7.1,0.8,10.7,0.9c8.2-0.1,16.5-0.4,24.5-0.7
			c3.5-0.1,7.1-0.3,10.6-0.4c5.8-0.2,11.6-0.4,17.4-0.5l6.6-0.2c0.5,0,1.1,0,1.6,0c0.6,0,1.2,0,1.8,0c2.1-0.1,4.1-0.1,6.2-0.2
			c5-0.2,10.3-0.4,15.4-0.4c2.4,0,4-0.8,5.3-2.6c0.8-1.3,1.5-2.7,1.9-4.2l0.7-2.2c2.7-8.9,5.5-18.1,7.2-27.5
			c0.2-0.9,0.3-1.8,0.5-2.7C143.4,87.6,144.8,80,144.3,72.5z M123.7,123.3c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0.1-0.3,0.2-0.5,0.2
			c-0.7,0.1-1.5,0.2-2.3,0.3c-1.8,0.2-3.6,0.4-5.5,0.5c-3,0.1-6.1,0.2-9.1,0.3c-4,0.1-8.1,0.2-12.1,0.5c-4.7,0.3-9.5,0.7-14.1,1
			c-2.7,0.2-5.3,0.4-8,0.6c-3.9,0.3-7.1,0.5-10.5,0.6c-8.3,0.3-16.7,0.5-24.9,0.7l-4,0.1h-0.1c-0.4,0-0.7-0.1-1.1-0.1
			c-0.1,0-0.2,0-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.3-0.4L19.5,92.8c-0.1-0.2-0.1-0.4,0-0.6s0.2-0.3,0.3-0.5
			c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0,0.5,0.1l1.4,0.9c0.9,0.6,1.8,1.1,2.6,1.6c1.2,0.8,2.4,1.5,3.6,2.2c2.9,1.9,6,3.8,8.9,5.8
			c1.9,1.3,3.5,1.8,4.9,1.5c1.3-0.3,2.5-1.3,3.6-3.2l1-1.6c1.8-3.1,3.7-6.3,5.3-9.6c5.2-10.9,10.3-22,15.4-32.8
			c2-4.2,4-8.5,5.9-12.7c0.2-0.4,0.3-0.7,0.6-1.2l0.5-1c0.1-0.2,0.2-0.3,0.4-0.4c0.2-0.1,0.3-0.1,0.5-0.1c0.2,0,0.3,0.1,0.5,0.2
			c0.1,0.1,0.3,0.2,0.3,0.4c0.7,1.7,1.5,3.4,2.2,5c1.6,3.5,3,6.9,4.3,10.4c2.9,8,5.7,16.1,8.5,24c1.6,4.5,3.2,9,4.7,13.5
			c0.8,2.3,1.7,4.6,2.7,6.7c0.3,0.8,0.9,1.5,1.5,2.1c0.7,0.6,1.5,1,2.3,1.2c1.7,0.3,3.4-0.2,4.9-1.6c2.3-2.1,4.6-4.2,7-6.3
			c2-1.8,4.1-3.7,6.1-5.5c2.6-2.3,5.2-4.6,7.8-6.9l3.5-3.1c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.3,0,0.5,0l0.6,0.3
			c0.2,0.1,0.4,0.2,0.5,0.4c0.1,0.2,0.1,0.4,0.1,0.6C131.8,94.3,129.2,108.7,123.7,123.3z"
                />
              </g>
            </g>
          </svg>
          <span class="option-text">Embajadores</span>
        </ion-button>
      </a>
      <a [attr.href]="!disabled ? 'https://copyfly.es/imprimir-online-business' : null">
        <ion-button [disabled]="disabled" [routerLinkActive]="['is-active']">
          <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 150 150"
            style="enable-background: new 0 0 150 150"
            xml:space="preserve"
          >
            <style type="text/css">
              .st0 {
                clip-path: url(#SVGID_2_);
              }
            </style>
            <g id="Layer_1"></g>
            <g>
              <g>
                <defs>
                  <rect id="SVGID_1_" x="2.6" y="12" width="144.7" height="116.4" />
                </defs>
                <clipPath id="SVGID_2_">
                  <use xlink:href="#SVGID_1_" style="overflow: visible" />
                </clipPath>
                <g>
                  <path
                    d="M146.9,75c0.1-11.2-0.3-21-1.1-29.9c-1.1-12.5-8-19.4-20.1-19.9c-5.1-0.2-10.3-0.1-15.4,0.1c-2.3,0.1-4.7,0.2-7,0.2
				c-0.8,0-1.5,0-2.1,0h-0.3c-0.3-0.8-0.5-1.5-0.8-2.2c-0.6-1.8-1.2-3.4-1.8-5.1c0-0.1,0-0.2-0.1-0.2c-0.3-1.1-0.9-2.2-1.8-3
				c-1.6-1.8-3.8-2.7-6.6-2.7c-3.8,0.1-7.6,0.2-11.3,0.2c-5.7,0.1-11.6,0.2-17.4,0.4c-3.1,0.1-4.8,0.7-5.9,2
				c-0.7,0.4-1.3,1.1-1.7,1.8c-1.4,2.9-2.2,6.1-2.3,9.4h-0.9c-1.5,0-2.9,0-4.2,0c-1.6,0-3.3,0-4.9,0c-4,0-8.1,0-12.2,0.1
				c-5,0.2-9.8,1.3-14.4,3.3C8.2,32.3,5,36.8,4.8,43.3c-0.1,4.4-0.3,9-0.5,13.3C4.2,60.4,4,64.4,3.9,68.2c-0.1,2.1-0.1,4.2-0.1,6.2
				c0,3.6,0,7.3-0.3,10.9c-0.8,9.1-0.7,16.4,0.5,23c1,6,3.8,10.8,8,13.9c3.8,2.9,8.5,4.6,13.4,4.8c2.5,0.1,5.1,0.1,7.6,0.2
				c6.3,0.2,12.8,0.4,19.2,0.5c13.6,0.1,26.3,0.2,38.5,0.2c5.6,0,11.1,0,16.5,0c6.1,0,12.7-0.3,20.2-0.9c9.4-0.7,15.8-5.9,18.5-15
				c0.9-3,1.4-6.2,1.4-9.4c0-4.6-0.1-9.3-0.2-13.9C146.9,84.2,146.8,79.5,146.9,75z M139,89.7c0,4.4,0.1,8.8,0.2,13.2
				c0,3.4-0.8,6.8-2.3,9.8c-1.4,2.8-3.6,4.5-6.3,4.9c-3,0.6-6.1,1-9.2,1.1c-10.9,0.1-22,0.1-32.8,0.1c-3.9,0-7.8,0-11.6,0
				c-4,0-7.9,0-11.9,0c-9.6,0-19.5,0-29.2,0c-3.7,0-7.3-0.2-11-0.7c-6.8-0.8-11.5-5.5-12.8-12.6c-1.4-7.9-1.3-16.1-1.1-23.9
				c0-1.4,0.1-2.7,0.1-4.1c0-2.3,0.1-4.6,0.1-7c1.4,0.3,2.9,0.5,4.4,0.5c3.5,0.1,7.1,0.1,10.5,0.1c1.6,0,3.3,0,4.9,0
				c0.6,0,1.3,0,2,0.1c0.2,0,0.4,0,0.6,0c0,0.7,0,1.3,0,1.9c0,1.7,0,3.4,0,5c0.1,3.5,1.5,5.1,4.8,5.6c3.1,0.3,6.3,0.5,9.4,0.5h0.1
				c6.1,0,8.3-2.3,8.4-8.6c0-1.1,0-2.2,0-3.3v-1h40.4c0,0.1,0,0.3,0,0.4c0,0.7,0,1.3,0,1.9c0,1.1,0.1,2.1,0.2,3.1
				c0.4,3.7,2,5.3,5.6,5.4c2.9,0.1,6,0.1,9.2-0.1c3.1-0.2,5-1.9,5.5-5.1c0.2-1.4,0.3-2.8,0.4-4.3c0-0.5,0.1-1.1,0.1-1.7h4.5
				c4.4,0,8.8,0,13.1,0c1.2,0,2.3,0,3.5-0.2C138.8,77.1,138.9,83.4,139,89.7z M66.4,19.7c3.7-0.1,7.5-0.2,11.2-0.2
				c3.9,0.1,7.9,0.2,11.9,0.3c0.3,0,0.7,0,1,0.1c0.4,0.4,0.6,0.9,0.7,1.5c0.3,1.1,0.6,2.2,1,3.2c0.1,0.5,0.2,0.9,0.2,1.4H58.7
				C60.1,19.9,60.1,19.9,66.4,19.7L66.4,19.7z M110.2,71.2c0,0.2,0,0.3-0.1,0.5c-0.1,0.9-0.2,1.7-0.4,2.6c-0.1,0.4-0.4,0.6-0.7,0.8
				c-1.6,0.2-3.3,0.3-5,0.3c-0.5,0-0.9,0-1.4,0.1l-0.5-4.3H110.2z M48.5,71.3v5.2h-8.3l-0.7-4.9C41.2,70.9,45.5,70.8,48.5,71.3
				L48.5,71.3z M138,62.7c-0.2,0-0.4,0-0.5,0c-0.9,0-1.9,0.1-2.8,0.1c-2,0.1-4.2,0.2-6.2,0.2c-9.7,0.1-19.3,0.2-29,0.4
				c-8.6,0.1-17.3,0.2-25.9,0.3c-16.6,0.2-33.1,0.4-49.7,0.7l-12.6,0.2c0.1-4,0.3-8,0.4-11.9c0.1-2.1,0.2-4.1,0.2-6.2
				c0.3-7.8,1.7-9.7,9-11.5c4.5-1.2,9.1-1.8,13.7-1.9c9.8-0.1,19.6-0.1,29-0.1c7.7,0,15.7,0,23.5,0c4.5,0,9-0.2,13.4-0.4
				c3.5-0.2,7.1-0.3,10.6-0.4c4.9-0.1,9.9-0.2,14.8,0.3c7.2,0.8,10.5,4.1,11.5,11.6c0.6,4.1,0.9,8.2,1.1,12.3c0,2.1,0.1,4.2,0.1,6.3
				C138.4,62.7,138.2,62.7,138,62.7L138,62.7z"
                  />
                </g>
              </g>
            </g>
          </svg>
          <span class="option-text">Business</span>
        </ion-button>
      </a>
    </ion-buttons>

    <div class="flex items-center justify-center">
      <ng-container *ngIf="!this.authService.loggingOut; else loadingTemplate">
        <ng-container *ngIf="!userService.userG?.isAnonymous; else loginSection">
          <ion-avatar class="avatar">
            <img
              class="h-full w-full"
              src="{{ userService.userG?.photoURL ? userService.userG?.photoURL : '/assets/images/blank-profile.png' }}"
            />
          </ion-avatar>
          <ion-button routerLink="/account" [disabled]="disabled" class="menu-button" fill="clear">
            <span>Mi Cuenta</span>
          </ion-button>
        </ng-container>
      </ng-container>

      <ng-template #loadingTemplate>
        <ion-spinner name="crescent" class="spinner mr-[100px]" color="light"></ion-spinner>
      </ng-template>

      <ng-template #loginSection>
        <div class="loginSection">
          <ion-button routerLink="/auth/login" fill="clear" router-direction="forward">Inicia sesión</ion-button>
          <ion-button routerLink="/auth/signup" fill="clear" router-direction="forward">o regístrate</ion-button>
        </div>
      </ng-template>

      <ion-button
        [disabled]="disabled"
        class="price"
        color="clear"
        *ngIf="this.cartService.cart.items.length"
        (click)="cartService.openCartPreviewMenu()"
      >
        <svg
          class="iconWhite shoppingCartIcon"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 145 140"
          style="enable-background: new 0 0 145 140"
          xml:space="preserve"
        >
          <path
            d="M4.1,7.8c0.5,0.3,1.1,0.5,1.6,0.8C7,9,8.2,9.4,9.5,9.9c3.5,1.2,7,2.5,10.6,3.7c4.6,1.5,9.3,3,13.9,4.4l1.8,0.6
          c0.9,0.2,1.6,0.7,2.2,1.3s1,1.5,1.1,2.4c0.4,2,0.8,4.1,1.2,6.1c0.4,1.8,0.7,3.6,1.1,5.5c0.5,2.9,1.1,5.7,1.6,8.6
          c1.4,7.6,2.9,15.4,4.1,23.2c0.7,4.3,1.1,8.8,1.4,13.1c0.4,3.9,0.7,8,1.3,12l0.1,1.1c0.7,5.1,1.4,9.8,1.3,14.8
          c-0.1,9.4,3.6,13.3,13.3,14c7.4,0.6,14.8,0.8,22.3,0.8c8.7,0,17.3-0.3,25.8-0.5c6.9-0.2,14-0.4,21-0.5h0.2c0.9,0,1.8-0.1,2.7-0.3
          l0.4-0.1c1.3-0.3,2.6-0.8,3.8-1.5c0.8-0.5,1.5-1.2,2-2.1c0.5-0.9,0.7-1.8,0.7-2.8c0-0.9-0.3-1.9-0.9-2.7c-0.5-0.8-1.2-1.4-2.1-1.9
          c-1.8-0.9-3.8-1.4-5.8-1.4c-5.3,0.1-10.7,0.2-15.9,0.4c-6.8,0.2-13.9,0.4-20.8,0.5c-7.8,0.1-15.7-0.1-23.3-0.3c-3-0.1-6-0.1-9-0.2
          c-0.6,0-1.2-0.1-1.8-0.2c-0.3,0-0.5-0.1-0.8-0.1l-2.4-12.5l2.1-0.2c1.9-0.2,3.6-0.3,5.3-0.5l10-0.9c12.6-1.1,25.6-2.2,38.4-3.3
          c4.9-0.4,8.2-2.8,10.1-7.3l0.6-1.4c1.1-2.9,2.4-5.6,3.8-8.3c3.9-6.9,6.7-14.4,9.5-21.6l0.7-1.9c1.5-4,3.3-9.4,3.2-15.3
          c-0.1-4.8-2.2-7.2-7.1-7.5c-0.7-0.1-1.3-0.1-2.1-0.1c-5.5,0-10.9,0-16.4,0.1c-13.7,0-28,0.1-41.9,0.3c-5.5,0.1-11.1,0.4-16.4,0.7
          c-2.6,0.1-5.2,0.3-7.8,0.4c-0.6,0-1.1,0-1.8,0l-0.4,0c-0.2-0.7-0.3-1.5-0.5-2.2c-0.5-2-0.9-3.9-1.4-5.9c-1.3-5.1-4.2-8.2-8.9-9.6
          c-7.1-2.1-14.2-4.3-21.1-6.5c-3.3-1.1-6.7-2.1-10-3.1C7.7,0.9,6.9,0.7,6.2,0.7c-1.6-0.1-3.8,0-4.4,2.5C1.3,5.2,2.1,6.7,4.1,7.8z
           M51.9,35.1c0.7,0,1.4-0.1,2.2-0.1c2.1-0.1,4.1-0.2,6.1-0.2c4.4,0,8.9,0,13.2,0c3.7,0,7.4,0,11,0c6.2,0,12.4,0,18.5,0
          c8.3,0,16.6,0,24.9,0c1.8,0,3.6,0.1,5.5,0.3c0.7,0,1.4,0.1,2.2,0.1c-0.3,1-0.5,1.9-0.8,2.8c-0.6,2.4-1.3,4.7-2.2,6.9
          c-2.4,5.6-5.1,11.2-7.6,16.7c-1,2-1.9,4.1-2.9,6.1c-1.2,2.7-2.5,5.3-3.8,8.2l-1.9,4l-56.9,5.4C58.5,70.3,56.1,54.3,51.9,35.1z"
          />
          <path
            d="M123.3,138.7c2.5,0,4.9-1,6.7-2.8c0.8-0.7,1.4-1.6,1.8-2.6c0.4-1,0.6-2,0.6-3.1c0-4.5-4.3-8.6-9-8.7h-0.1
          c-2.3,0-4.5,0.9-6.2,2.5c-1.7,1.6-2.6,3.8-2.7,6.1c0,1.1,0.2,2.2,0.6,3.2c0.4,1,1,1.9,1.8,2.7c0.9,0.9,1.9,1.5,3,2
          C120.8,138.5,122,138.7,123.3,138.7L123.3,138.7z"
          />
          <path
            d="M69.5,139.4L69.5,139.4c2.3,0,4.4-0.9,6-2.4c1.6-1.5,2.5-3.6,2.6-5.8c0.1-4.8-4.2-9.4-8.7-9.5
          c-2.2,0-4.3,0.9-5.8,2.5c-1.8,1.7-2.8,4-2.9,6.5c0,1.1,0.3,2.2,0.7,3.3c0.4,1,1.1,2,1.9,2.7C64.9,138.3,67.1,139.3,69.5,139.4z"
          />
        </svg>
        <ion-badge color="danger" slot="end" style="position: absolute; right: -5px; top: -0px">
          {{ this.cartService.cart.items.length }}
        </ion-badge>
      </ion-button>
      <ion-button class="help-button" color="clear" (click)="abrirFaqSidebar()">
        <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve">
          <g id="help_circle">
            <g>
              <path
                d="M20,38.6L20,38.6c0.3,0.1,0.6,0.3,0.9,0.4c3.3,2.3,6.7-1.8,5-5.3C22.5,30.1,16.3,35.5,20,38.6z M24.3,37.1    c-0.6,0.6-1.5,0.9-2.8,0.8c-0.2-0.1-0.4-0.2-0.7-0.4l0,0c-0.3-2.1,1.1-2.5,3.1-2.3C23.6,36.3,24.5,36.2,24.3,37.1z M32.5,13    c-3.8-8.2-20.3-2.8-18.3,7.2c1.4,0,2.9,0,4.3,0c0.3-0.1,0.5-0.3,0.4-0.8l-0.1-0.1c1.4-1.7,3.5-3.8,6-3.6c0.4,0.5,1.7,0.2,1.9,1    c1.6,6.5-8.6,4.7-6.6,12.8c0.8,0.2,1.8,0.6,2.5,0.2c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.6-0.1,1.2-0.2,1.9-0.2l1-0.1l0.2-0.3    c0.8-1.2,1.9-2.3,3.1-3.6c3.2-3.3,6.7-7,4-12.3C32.8,13.1,32.6,13,32.5,13z M27.7,24.6c-1.1,1.1-2.2,2.3-3,3.5l-0.2,0    c-0.7,0.1-1.4,0.1-2,0.3c0,0,0,0-0.1,0c-0.9-4.9,6.1-4.6,6.6-8.9c0.2-1.8-0.2-5-3.9-4.9l0,0.1c-3-0.4-5.4,1.8-7.1,3.7    c-0.5,0-1,0-1.5,0c0.1-6.9,10.7-9.2,14.9-4.4c0,0,0,0,0,0C33.7,18.3,30.8,21.3,27.7,24.6z M41.4,4.7c-3.9-3.1-13.8-5.3-20.6-4.1    c-3.9,0.6-8,1.6-10.9,3.4C-1.4,11-3.3,32.5,5.6,41.7C9.9,46,18.8,50.6,27,49.9c8.4-0.6,19.4-10.1,21.8-16.6    C52.4,23.5,47.2,9.3,41.4,4.7z M44.5,31.5C42.9,36.1,33.3,45.2,27,46.2C15.4,48,3.7,38.4,2.5,28.5C0.9,14.8,7.6,5.8,19.6,4    c9.5-1.4,17.7,1.3,21.8,7.5C44.7,16.6,46.5,26.1,44.5,31.5z"
              ></path>
            </g>
          </g>
        </svg>
      </ion-button>
    </div>
  </div>
</ion-toolbar>
